import { Component, OnInit } from "@angular/core";
import { SkuManagementService } from "../sku-management.service";
import { LoggingService } from "src/app/core/services/logging.service";

@Component({
    selector: "app-sku-download-template",
    templateUrl: "./sku-download-template.component.html",
    styleUrls: ["./sku-download-template.component.scss"],
    standalone: false
})
export class SkuDownloadTemplateComponent implements OnInit {
  downloadLink: string;
  constructor(private skuManagementService: SkuManagementService) {}

  ngOnInit() {
    this.skuManagementService.getTemplateLink$().subscribe(
      link => {
        this.downloadLink = link;
      },
      err => {},
      () => {
        LoggingService.log("sku template complete");
      }
    );
  }
}
